import { Component, OnInit , Input, Output, EventEmitter} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'user-filter',
  templateUrl: './user-filter.component.html',
  styleUrls: ['./user-filter.component.css']
})
export class UserFilterComponent implements OnInit {

  selectedOption: string = 'all';
  @Input() filter: {
    all: string,
    approved: string,
    analysis: string,
    negate: string,
  }

  @Input()blocked: boolean = false;

  constructor(private translate: TranslateService) {

  }

  ngOnInit(): void {
  }

  @Output() spanClicked: EventEmitter<string> = new EventEmitter();

  onspanClicked() {
    this.spanClicked.emit(this.selectedOption);
  }

  emitupdateStatus(updateStatus){
    if(!this.blocked)
    {
    this.selectedOption = updateStatus;
    this.onspanClicked();
    }
  }

}
